export interface ReferralSourceSummaryRow {
    leadCount: number;
    movedCount: number;
    movedWithMoveDate: number;
    totalDaysToMove?: number | null;
    closedNoMoveCount: number;
    activeCount: number;
    totalInvoicedCents: number;
}

export interface ReferralSourceSummary {
    totalContacts: number;
    totalLeads: number;
    totalMoved: number;
    totalClosedNoMove: number;
    totalActive: number;
    moveRate: number | null;
    avgDays: number | null;
    totalInvoiced: number;
}

export const computeReferralSourceSummary = (
    rows: ReferralSourceSummaryRow[],
): ReferralSourceSummary => {
    const totalLeads = rows.reduce((s, c) => s + c.leadCount, 0);
    const totalMoved = rows.reduce((s, c) => s + c.movedCount, 0);
    const totalClosedNoMove = rows.reduce((s, c) => s + c.closedNoMoveCount, 0);
    const totalActive = rows.reduce((s, c) => s + c.activeCount, 0);
    const totalInvoiced = rows.reduce((s, c) => s + c.totalInvoicedCents, 0);
    const moveRate = totalLeads > 0 ? totalMoved / totalLeads : null;

    const rowsWithDates = rows.filter(
        r => r.movedWithMoveDate > 0 && r.totalDaysToMove != null,
    );
    const totalDays = rowsWithDates.reduce((s, r) => s + (r.totalDaysToMove ?? 0), 0);
    const totalMovedWithDates = rowsWithDates.reduce(
        (s, r) => s + r.movedWithMoveDate,
        0,
    );
    const avgDays =
        totalMovedWithDates > 0 ? Math.round(totalDays / totalMovedWithDates) : null;

    return {
        totalContacts: rows.length,
        totalLeads,
        totalMoved,
        totalClosedNoMove,
        totalActive,
        moveRate,
        avgDays,
        totalInvoiced,
    };
};
